import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { InlineLink } from '@zocdoc-mezzanine/components-link';
import {
    labelExtraSmall,
    paragraphExtraSmall,
} from '@zocdoc-mezzanine/foundations-typography';
import { MFAVerificationTypes } from './constants';
import { MFAVerificationContact } from './MFAVerificationContact';

/**
 *
 * @property {boolean} isCodeResent - condition for which footer to display
 * @property {function(verificationMethod: MFA_VERIFICATION_TYPE): void} handleResendCode - function for resending verification code via sms or phone call
 * @
 * @returns {JSX.Element|null} MFAVerificationFooter
 */

export const MFAVerificationFooter = ({ isCodeResent, handleResendCode }) => {
    return (
        <FooterContent data-test="verification-form-footer">
            {isCodeResent ? (
                <FooterText>
                    <span data-test="mfa-code-sent">Code sent!</span>
                </FooterText>
            ) : (
                <FooterText>
                    <span>
                        <span>Didn't get a code? </span>
                        <span>
                            Get another by
                            <StyledLink>
                                <InlineLink
                                    onClick={() =>
                                        handleResendCode(
                                            MFAVerificationTypes.sms
                                        )
                                    }
                                    data-test="resend-verification-code-sms"
                                >
                                    text
                                </InlineLink>
                            </StyledLink>
                            or
                            <StyledLink>
                                <InlineLink
                                    onClick={() =>
                                        handleResendCode(
                                            MFAVerificationTypes.call
                                        )
                                    }
                                    data-test="resend-verification-code-call"
                                >
                                    phone call
                                </InlineLink>
                            </StyledLink>
                        </span>
                    </span>
                </FooterText>
            )}
            <MFAVerificationContact />
        </FooterContent>
    );
};

const FooterContent = styled.div`
    margin-top: 12px;
`;

const FooterText = styled.div`
    ${paragraphExtraSmall};
    display: flex;
    flex-direction: column;
    align-items: center;

    ${breakpoint.small} {
        display: block;
        text-align: center;
    }
`;

const StyledLink = styled.span`
    ${labelExtraSmall};
    text-decoration: underline;
    padding: 0px 2px;
`;
